import Layout from "../../components/Layout/Layout";
import CourseHighLight from "./components/CourseHighLight/CourseHighLight";
import SessionCard from "./components/SessionCard/SessionCard";
import TrainingDetailsHeader from "./components/TrainingDetailsHeader/TrainingDetailsHeader";
import "./TrainingDetails.scss";
import useTrainingDetails from "./logic/useTrainingDetails";
import dayjs from 'dayjs';
import Mouse from "../../components/Mouse/Mouse";
import ScrollTop from "../../components/ScrollTop/ScrollTop";
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle";

function TrainingDetails() {
  const { trainingData } = useTrainingDetails();

  function groupSessionsByIndex(sessionsByDate) {
    const indexedSessions = {};
    let index = 1;

    if (sessionsByDate) {
      const sortedDates = Object.keys(sessionsByDate).sort();
      sortedDates.forEach((date) => {
        indexedSessions[index.toString()] = sessionsByDate[date];
        index++;
      });
    }

    return indexedSessions;
  }

  function sortSessionsByDateAndTime(sessionsByDate) {
    const sortedSessions = {};
    Object.keys(sessionsByDate).sort().forEach((date) => {
      const sessions = sessionsByDate[date];
      sortedSessions[date] = sessions.sort((a, b) => {
        const startTimeA = dayjs(a.date + ' ' + a.from, 'YYYY-MM-DD hh:mm a').unix();
        const startTimeB = dayjs(b.date + ' ' + b.from, 'YYYY-MM-DD hh:mm a').unix();
        return startTimeA - startTimeB;
      });
    });
    return sortedSessions;
  }

  const sessionsGroupedByIndex = groupSessionsByIndex(
    trainingData?.sessionsGroupedByDate
  );

  const sortedSessionsByDateAndTime = sortSessionsByDateAndTime(sessionsGroupedByIndex);

  return (
    <div className="training-details-container">
      <FlatTitle pageName={"Training Details"} />
      <div className="section-container">
        <div id="wrapper">
      <div className="training-details">
        <TrainingDetailsHeader />
        <div className="training-details-body">
          <div className="training-session">
            {Object.keys(sortedSessionsByDateAndTime).length === 0 ? (
              <div className="no-data-message">
                No sessions found for this training
              </div>
            ) : (
              <div>
                {Object.keys(sortedSessionsByDateAndTime).map((dayNumber, index) => (
                  <SessionCard
                    key={index}
                    dayNumber={dayNumber}
                    sessions={sortedSessionsByDateAndTime[dayNumber]}
                  />
                ))}
              </div>
            )}
          </div>
          <div className="training-highLight">
            <CourseHighLight />
          </div>
        </div>
      </div>
          <Mouse />
          <ScrollTop />
        </div>
      </div>
    </div>
  );
}
export default TrainingDetails;
